import { Component, OnInit, Inject, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { DialogData } from 'app/core/interfaces/dialog';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { paymentI, paymentMethodInitialState } from 'app/core/interfaces/payment';

@Component({
  selector: 'page-payment-details',
  templateUrl: './payment-details.component.html',
  styleUrls: ['./payment-details.component.scss']
})
export class PaymentDetailsComponent extends BaseComponent implements OnInit {

  public method: paymentI = paymentMethodInitialState;
  public active = true;

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private injector: Injector 
  ) {
    super(injector);
   }

  ngOnInit(): void {
    this.method = this.data.param.method;
  }

  toogleStatusActive() {
    if (this.method){
      this.method.active = !this.active;
      //@TODO PUT status
      //temporario localstorage
      this.auth.updateLocalStorageById('paymentMethods',this.method.id as number, this.method);
    }    
  }

}
